<p-dialog id="searchdoc"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          appendTo="body"
          [style]="{width: '85vw', height: '85vh'}">

  <ng-template pTemplate="content">
    <div class="grid formgrid fluid">
      <div class="col-6 sm:col-12 mt-4 mr-2">
        <span class="p-float-label">
          <input id="doc-input" type="text" pInputText (keyup.enter)="onSearch($event)" [(ngModel)]="docStrString">
          <label for="doc-input">Поиск по полям документа...</label>
        </span>
      </div>
      <div class="col-6 sm:col-12 mt-4 mr-2">
          <span class="p-float-label">
            <input id="cli-input" type="text" pInputText (keyup.enter)="onSearch($event)" [(ngModel)]="cliStrString">
            <label for="cli-input">Поиск по полям контрагента...</label>
          </span>
      </div>
      <div class="col-6 sm:col-12 mt-4 mr-2">
        <div class="fluid">
          <span class="p-float-label">
            <input id="lco-input" type="text" pInputText (keyup.enter)="onSearch($event)" [(ngModel)]="lcoStrString">
            <label for="lco-input">Поиск по полям юрлица...</label>
          </span>
        </div>
      </div>
      <div class="col-6 sm:col-12 mt-4 mr-2">
        <div class="fluid">
          <span class="p-float-label">
            <input id="pro-input" type="text" pInputText (keyup.enter)="onSearch($event)" [(ngModel)]="proStrString">
            <label for="pro-input">Поиск по полям товара...</label>
          </span>
        </div>
      </div>
    </div>
    <div class="grid formgrid justify-content-end">
        <p-button label="Найти"  icon="pi pi-search" (click)="onSearch($event)" class="mt-4 mb-4 mr-2"></p-button>
    </div>

    <div class="grid">
      <div class="col-12">
        <div>
          <p-table [value]="datasource"
                   [loading]="loading"
                   [rows]="rows"
                   styleClass="p-datatable p-datatable-sm p-datatable-gridlines p-datatable-striped p-datatable-customers"
                   dataKey="DOCID"
                   [showCurrentPageReport]="true"
                   [totalRecords]="totalRecords"
                   [paginator]="true"
                   currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
                   [resizableColumns]="true"
                   selectionMode="single"
                   [(selection)]="selection"
                   (onRowSelect)="onRowSelect($event)"
                   [rowHover]="true">

            <ng-template pTemplate="header">
              <tr>
                <th  style="width: 3rem"></th>
                <th pResizableColumn style="width: 3rem !important"></th>
                <th pResizableColumn style="width: 8% !important">Документ </th>
                <th pResizableColumn style="width: 6% !important">Номер </th>
                <th pResizableColumn style="width: 6% !important">Дата </th>
                <th pResizableColumn style="width: 6% !important">Валюта </th>
                <th pResizableColumn style="width: 8% !important">Продавец </th>
                <th pResizableColumn style="width: 8% !important">Автор </th>
                <th pResizableColumn style="width: auto !important">Контрагент </th>
                <th pResizableColumn style="width: 6% !important">Сумма </th>
                <th pResizableColumn style="width: 6% !important">Оплачено </th>
                <th pResizableColumn style="width: 6% !important">Отгружено </th>
                <th pResizableColumn style="width: 8% !important" class="do-not-overlay-text">Пр. продавца </th>
                <th pResizableColumn style="width: 8% !important" class="do-not-overlay-text">Пр. покупателя </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-dlCurr let-expanded="expanded">
              <tr [pSelectableRow]="dlCurr"
                  [class.futuredocs]="dlCurr.fd"
                  [class.grayout]="dlCurr.go"
                  [class.underline]="dlCurr.ps"
                  [class.strikeout]="dlCurr.fs"
                  [class.partiallypaiddoc]="dlCurr.pp"
                  [class.notpaiddoc]="dlCurr.np"
                  [class.fullypaiddoc]="dlCurr.fp"
                  [class.todaydocuments]="dlCurr.td"
                  [class.proformadoc]="(dlCurr.DOCTYPEID == 12)"
                  [class.inorderdoc]="(dlCurr.DOCTYPEID == 2)"
                  [class.banktransferdoc]="(dlCurr.DOCTYPEID == 9)"
                  [class.purchorderdoc]="(dlCurr.DOCTYPEID == 10)"
                  [class.yellowdoc]="(dlCurr.DOCTYPEID == 14)"
                  [class.specdoc]="(dlCurr.DOCTYPEID == 7)"
                  [class.shiporderdoc]="(dlCurr.DOCTYPEID == 4)"
                  [class.invoicedoc]="(dlCurr.DOCTYPEID == 1)">
                <td style="width: 3rem">
                  <p-tableRadioButton [value]="dlCurr"></p-tableRadioButton>
                </td>
                <td>
                  <button type="button" pButton pRipple [pRowToggler]="dlCurr" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td style="max-width: 12rem !important">{{dlCurr.DOCNAME}}</td>
                <td >
                  <a [routerLink]="['/edit-document', dlCurr.DOCTYPEID, dlCurr.DOCID]">{{dlCurr.DOCNUMBER}}</a>
                </td>
                <td class="CellWithComment" >
                  <span class="CellComment">{{dlCurr.DOCVALDATE | date:'dd.MM.yyyy'}}<br />{{dlCurr.DOCEXPDATE | date:'dd.MM.yyyy'}}</span>{{dlCurr.DOCDATE | date:'dd.MM.yyyy' }}
                </td>
                <td >{{dlCurr.CURSTR}}</td>
                <td >{{dlCurr.LOCALCOMP}}</td>
                <td >{{dlCurr.AUTHOR}}</td>
                <td class="CellWithComment" style="max-width: 15rem !important">
                  <span class="CellComment">{{dlCurr.PARTNERNAMESTR}}</span>
                  <a [routerLink]="['/edit-client', dlCurr.DOCCLIENTSID]">{{dlCurr.PARTNERNAMESTR}}</a>
                </td>

                <td style="text-align: right">{{dlCurr.DOCSUM | number:'1.2-2'}}</td>
                <td style="text-align: right">{{dlCurr.PAYDSUM | number:'1.2-2' }}</td>
                <td style="text-align: right">{{dlCurr.SHIPSUM | number:'1.2-2' }}</td>
                <td style="max-width: 10rem !important"><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE1" [style]="{'width':'100%'}" readonly alt="{{dlCurr.DOCNOTE1}}"></td>
                <td style="max-width: 10rem !important"><input pInputText type="text" [(ngModel)]="dlCurr.DOCNOTE2" [style]="{'width':'100%'}" readonly alt="{{dlCurr.DOCNOTE2}}"></td>
              </tr>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-dlCurr>
              <tr>
                <td colspan="14">
                  <app-document-content-table [selectedDocumentId]="dlCurr.DOCID"></app-document-content-table>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="14">Пока ничего не найдено...</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')" [disabled]="!selection"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
